import { render, staticRenderFns } from "./userPermissions.vue?vue&type=template&id=4c1b62fa"
import script from "./userPermissions.vue?vue&type=script&lang=js"
export * from "./userPermissions.vue?vue&type=script&lang=js"
import style0 from "./userPermissions.vue?vue&type=style&index=0&id=4c1b62fa&prod&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports